import { render, staticRenderFns } from "./listPoints.vue?vue&type=template&id=52de5b62&scoped=true&v-loading=loadsing"
import script from "./listPoints.vue?vue&type=script&lang=js"
export * from "./listPoints.vue?vue&type=script&lang=js"
import style0 from "./listPoints.vue?vue&type=style&index=0&id=52de5b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de5b62",
  null
  
)

export default component.exports